import { useApolloClient, useLazyQuery } from "@apollo/client/react";
import WorkOrderSearchContext from "contexts/WorkOrderSearchContext";
import useApplicationContext from "hooks/apollo/applicationContext/useApplicationContext";
import { useSchedulerState } from "hooks/state";
import useBryntumScheduler from "hooks/useBryntumScheduler";
import { useContext, useState } from "react";
import buildFilterQueryParameters from "./helpers/buildFilterQueryParameters";
import { insertWorkOrder, removeWorkOrder } from "./helpers/handleUpdateWorkOrders";
import { GetWorkOrderFiltered } from "./workOrder.gql";

export default function useGetWorkOrderFiltered() {
  const client = useApolloClient();
  const {
    state: { visibleTimeRange },
  } = useSchedulerState();
  const applicationContext = useApplicationContext();
  const { getBryntumScheduler } = useBryntumScheduler();
  const { state: searchState } = useContext(WorkOrderSearchContext);
  const [updatedWorkOrder, setUpdatedWorkOrder] = useState({});

  const buildQueryParameters = (workOrderId) =>
    buildFilterQueryParameters({
      applicationContext,
      bryntumScheduler: getBryntumScheduler(),
      visibleTimeRange,
      ...searchState,
      id: workOrderId,
    });

  const [getWorkOrderFilteredQuery] = useLazyQuery(GetWorkOrderFiltered);

  const getWorkOrderFiltered = (newWorkOrder = updatedWorkOrder) => {
    const query = getWorkOrderFilteredQuery({
      fetchPolicy: "no-cache",
      variables: buildQueryParameters(newWorkOrder.id),
    });
    query
      .then((result) => {
        const {
          workOrderFiltered: { filteredOut },
        } = result.data;
        if (filteredOut) {
          removeWorkOrder(newWorkOrder.id, client);
        } else {
          insertWorkOrder(newWorkOrder, client);
        }
      })
      .catch((err) => {
        // Ignore abort errors: abort errors are expected when a new request is made before the last one finishes.
        if (err.name !== "AbortError") throw err;
      });

    return query;
  };

  return {
    getWorkOrderFiltered,
    setUpdatedWorkOrder,
  };
}
